import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { toast } from "react-toastify";
import OfferImage, { resolveOfferImage } from "../OfferImage/OfferImage";
import SoftCard, { PriceRow } from "../SoftCard/SoftCard";
import { getToken } from "../../Utils/authHelper";
import { postData } from "../../Webservice/Webservice";
import { useCart } from "../../context/CartContext";

// Special deal (BOGO) card: the same soft, rounded look as the product and combo cards.
// The button adds a one-product deal straight to the cart; a deal with several products opens its page to choose.
const BogoCard = ({ bogo, width, scrollTop = false }) => {
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();
  const [adding, setAdding] = useState(false);
  const buyProducts = (bogo.buyProducts || []).map((x) => x.product_id).filter((p) => p && typeof p === "object");
  // a deal with a single buy product can go straight into the cart; otherwise the customer picks on the deal page
  const direct = buyProducts.length === 1;
  const first = (bogo.buyProducts || []).map((x) => x.product_id).find((p) => p && typeof p === "object");
  const mrp = Number(first?.b2c_mrp) || 0;
  const pct = Number(bogo.discountPercentage) || 100;
  const saved = mrp > 0 ? +(Number(bogo.getQuantity) * mrp * (pct / 100)).toFixed(2) : 0;
  const inStock = bogo.inStock !== false;
  const offerPics = bogo.product_images || [];
  const fallbackImg = resolveOfferImage(first?.product_images?.[0]);
  const title = first?.title || bogo.title || "Special Deal";
  const dealText = pct === 100
    ? `Buy ${bogo.buyQuantity} get ${bogo.getQuantity} free`
    : `Buy ${bogo.buyQuantity} get ${bogo.getQuantity} (${pct}% off)`;

  const open = () => { navigate(`/bogo-deal/${bogo._id}`, { state: { bogo } }); if (scrollTop) window.scrollTo(0, 0); };

  const quickAdd = async () => {
    if (!direct) { open(); return; }
    const token = getToken();
    if (!token) { navigate("/signin"); return; }
    setAdding(true);
    try {
      const units = Number(bogo.buyQuantity) || 1;
      const res = await postData("cart/add-to-cart", { product_id: buyProducts[0]._id, quantity: units }, `Bearer ${token}`, false, false);
      if (res && (res.success || res.cart || res.message === "Cart updated")) {
        fetchCartCount();
        toast.success("Deal added. The free item is applied automatically.");
      } else {
        toast.error(res?.message || "Could not add the deal");
      }
    } catch (err) {
      toast.error(err.message || "Could not add the deal");
    } finally {
      setAdding(false);
    }
  };

  return (
    <SoftCard
      width={width}
      onClick={open}
      outOfStock={!inStock}
      badge={saved > 0 ? `Save ₹${saved}` : dealText}
      image={
        offerPics.length > 0
          ? <OfferImage images={offerPics} alt={title} fit="cover" fill dotsTop imgClassName="soft-img" />
          : <img className="soft-img" src={fallbackImg || "https://via.placeholder.com/400x500"} alt={title} />
      }
      action={{ icon: direct ? <ShoppingCartOutlinedIcon sx={{ fontSize: 19 }} /> : <ArrowForwardIcon sx={{ fontSize: 19 }} />, label: direct ? "Add deal to cart" : "Choose & add", onClick: quickAdd, loading: adding }}
      kicker={saved > 0 ? dealText : "Special deal"}
      title={title}
    >
      <PriceRow price={mrp > 0 ? `₹${mrp.toFixed(0)}` : "Special Deal"} />
    </SoftCard>
  );
};

export default BogoCard;
